export type { Props as DumbProps } from './header-dumb';
export { default as DumbHeader } from './header-dumb';
